import { APP_AUTH_CONST } from "constant";
import CryptoJS from "crypto-js";

export function Encrypt(data: string) {
    if (process.env.REACT_APP_CRYPTOJS_PRIVATE_KEY) {
        return CryptoJS.AES.encrypt(data, process.env.REACT_APP_CRYPTOJS_PRIVATE_KEY).toString()
    }
    return null
}

export function Decrypt(data: string) {
    try {
        if (process.env.REACT_APP_CRYPTOJS_PRIVATE_KEY) {
            const bytes = CryptoJS.AES.decrypt(data, process.env.REACT_APP_CRYPTOJS_PRIVATE_KEY);
            return bytes.toString(CryptoJS.enc.Utf8)
        } else {
            localStorage.removeItem(APP_AUTH_CONST)
        }
        return null
    } catch (err) {
        localStorage.removeItem(APP_AUTH_CONST)
        return null
    }
}